// src/app/audit/AI/CoPilotV2/components/styled/ChatComponents.js
import styled from 'styled-components';

export const RoomItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  margin: 4px 0;
  border-radius: 4px;
  cursor: pointer;
  background-color: ${props => props.selected ? '#f0f7ff' : 'transparent'};
  
  &:hover {
    background-color: ${props => props.selected ? '#f0f7ff' : '#f5f5f5'};
  }
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #666;
  font-size: 18px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  
  &:hover {
    background-color: #ffebee;
    color: #d32f2f;
  }
`;

export const MessageBubble = styled.div`
  max-width: 70%;
  padding: 12px 16px;
  margin: 8px 0;
  border-radius: 12px;
  background-color: ${props => props.isUser ? '#e3f2fd' : '#f5f5f5'};
  align-self: ${props => props.isUser ? 'flex-end' : 'flex-start'};
  word-wrap: break-word;
`;

